module.exports = __webpack_public_path__ + "static/coach-hire-services-weddings-engagements-parties-night-out-18a3aae76553d97823de61d21173e315.jpg";